import React from "react";
import styled from "styled-components";

const TableSection = styled.div`
  margin: 4rem 0;
  @media only screen and (max-width: 768px) {
    overflow-x: auto;
  }
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const TableCell = styled.td`
  border: 2px solid #181e22;
  text-align: left;
  padding: 1.5rem;
`;

const TableHeaderCell = styled.th`
  border: 2px solid #181e22;
  text-align: left;
  padding: 1.5rem;
`;

const ScrollableTable = () => {
  return (
    <TableSection>
      <Table>
        <thead>
          <tr>
            <TableHeaderCell>MODEL NAME</TableHeaderCell>
            <TableHeaderCell align="right">USEFULNESS</TableHeaderCell>
            <TableHeaderCell align="right">
              FUNCTIONAL CORRECTNESS (0-4)
            </TableHeaderCell>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableCell>Interplay AppCoder LLM</TableCell>
            <TableCell align="right">2.968</TableCell>
            <TableCell align="right">2.476</TableCell>
          </tr>
          <tr>
            <TableCell>Wizard Coder</TableCell>
            <TableCell align="right">1.825</TableCell>
            <TableCell align="right">0.603</TableCell>
          </tr>
        </tbody>
      </Table>
    </TableSection>
  );
};

export default ScrollableTable;
